import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {UserOPEEnum} from "./UserOPEEnum";

/**
 * O Inner Class
 */
class O {
  id!: number;
}

/**
 * I Inner Class
 */
class I {
  userId!: number;
  newPartitionId!: number;
}

export class UpdateUserPartitionCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.UpdateUserPartition);
    this.i = new I();
    this.o = new O();
  }
}
